module.exports = __webpack_public_path__ + "static/img/aboutus-img5.d7d766d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus-img5.jpg
// module id = O8YQ
// module chunks = 39